import mutations from './mutations'
// import actions from './actions'

const state = {
    isNext:false,
    beforeData:{},
    sendObj:[],//英语教师发作业信息
    taskCatalog:[],//同步习题所选章节id
    taskQids:[],
    title:'', //教师发作业需要
    task_name:null,  //设置英语的结果页的title
    PlayStatus:true,  // 设置听力题的听力条是否在走
    audioId:null,//当前听力题id
};


export default {
  state,
  mutations
}
